module.exports = __webpack_public_path__ + "media/elephant_xl.555dbe8d.webm";